import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImprimirPesosComponent } from './imprimir-pesos.component';
import { ButtonModule } from 'primeng/button';
import {TableModule} from 'primeng/table';
import { ImprimirInformeCabeceraSharedModule } from '../imprimir/partes/informe-cabecera/imprimir-informe-cabecera.module.share';



@NgModule({
    declarations: [ImprimirPesosComponent],
    imports: [ 
        CommonModule,
        ImprimirInformeCabeceraSharedModule,
        ButtonModule,
        TableModule 
    ],
    exports: [ ImprimirPesosComponent ],
    providers: [],
})
export class ImprimirPesosSharedModule {}